// Here for React
const FrameWorkImage = {
    Coffe : require("../../Picture/Coffe.png"),
    Anime : require("../../Picture/Anime.png"),
    ShopWise : require("../../Picture/ShopWise.png"),
    ShopClothes : require("../../Picture/ShopClothes.png"),
    ShowRoom : require("../../Picture/ShowRoom.png"),
    BistroBliss : require("../../Picture/Bistro-Bliss.png"),
    instagram : require("../../Picture/instagram.png"),
}
export default FrameWorkImage
